const SWATCH_PALETTE = [
  'hsl(211,100%,56%)',
  'hsl(137,57%,41%)',
  'hsl(44,66%,50%)',
  'hsl(280,60%,58%)',
  'hsl(356,72%,47%)',
  'hsl(190,60%,45%)',
  'hsl(24,80%,55%)',
  'hsl(260,50%,60%)',
]

export function swatchColor(seed: string | number): string {
  const str = String(seed)
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i)
    hash |= 0
  }
  return SWATCH_PALETTE[Math.abs(hash) % SWATCH_PALETTE.length]
}
